import React from "react";
import API from "../../services/api.jsx";
import Loader from "../layout/loader.jsx";
import Head from "../layout/head.jsx";
import Content from "../layout/content.jsx";
import Table from "../layout/table.jsx";
import { debounce } from "lodash";
import Helpers from "../../services/helpers.jsx";

class UserRolesList extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      clients: [],
      loading: true,
      search: "",
      filters: {},
      sort: ["createdAt", "DESC"],
      tabs: {
        links: [
          { title: "Users", path: "/users/list" },
          { title: "Roles", path: "/users/roles" },
        ],
      },
      roles: {
        columns: [
          {
            label: "Name",
            key: "name",
            view: (_, entity) => {
              if (entity) {
                return entity?.name;
              }
              return "-";
            },
          },
          {
            label: "User(s)",
            key: "users",
          },
        ],
        entities: [],
        filters: [
          {
            label: "Search",
            onChange: debounce((value) => {
              if (value !== this.state.filters.name) {
                const newFilter = Helpers.cleanObject({
                  ...this.state.filters,
                  name: value,
                });
                this.setState({ filters: newFilter }, () => {
                  this.loadEntities();
                });
              }
            }, 500),
          },
        ],
        actions: [],
        selectedItems: [],
        multiSelect: false,
        onRowClick: (entity) => {
          if (Helpers.checkPermissions(["roles:details", "roles:edit"], true)) {
            this.props.history.push(`/users/roles/${entity.id}/edit`);
          }
        },
      },
    };
  }

  componentDidMount() {
    this.loadEntities();
  }

  loadEntities() {
    API.getRoles(this.state.filters, this.state.sort).then((entities) => {
      const filters = [];
      if (entities?.filters?.availableFilters) {
        Helpers.handleFilters(this, filters, entities);
      }

      this.setState({
        ...this.state,
        roles: {
          ...this.state.roles,
          filters,
          entities: entities?.data || [],
        },
        loading: false,
      });
    });
  }

  render() {
    if (this.state.loading) return <Loader />;
    else
      return (
        <>
          <Head title={"Roles"} tabs={this.state.tabs} />
          <Content>
            <Table
              settings={this.state.roles}
              loadEntities={this.loadEntities}
              sort={this.state.sort}
            />
          </Content>
        </>
      );
  }
}

export default UserRolesList;
